import { get } from '../xhr';

export function getMyReflections() {
	let url = 'user-reflection';
	return get(url);
}